import { render, staticRenderFns } from "./LearnHome.vue?vue&type=template&id=09780224&scoped=true&"
import script from "./LearnHome.vue?vue&type=script&lang=ts&"
export * from "./LearnHome.vue?vue&type=script&lang=ts&"
import style0 from "./LearnHome.vue?vue&type=style&index=0&id=09780224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09780224",
  null
  
)

export default component.exports